<script lang="ts">
  import { cn } from "$lib/utils/cn";

  interface Props {
    checked?: boolean;
    disabled?: boolean;
    class?: string;
    onchange?: (e: Event) => void;
  }

  let {
    checked = $bindable(false),
    disabled = false,
    class: className,
    onchange,
    ...restProps
  }: Props = $props();
</script>

<input
  type="checkbox"
  bind:checked
  {disabled}
  {onchange}
  class={cn(
    "h-4 w-4 rounded border border-border-default",
    "bg-surface-3 text-accent-primary",
    "focus:ring-1 focus:ring-accent-primary/20 focus:ring-offset-0",
    "disabled:opacity-50 disabled:cursor-not-allowed",
    "accent-accent-primary cursor-pointer",
    className
  )}
  {...restProps}
/>
